import React from 'react'
import './index.css'

const VarianceTitle = (props) => {

  return (
    <div className={props.hidden ? 'variance__title--hidden' : 'variance__title--jobpage'}>
      <p>Variance Check</p>
    </div>
  )

}

export default VarianceTitle
